import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/landing/dist/house/@section5/index.js");
